var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isReload)?_c('router-view'):_vm._e(),(_vm.$store.state.showLoading)?_c('Loading'):_vm._e(),_c('FormulaDlg',{attrs:{"visible":_vm.$store.state.formulaDlg.show},on:{"update:visible":function($event){return _vm.$set(_vm.$store.state.formulaDlg, "show", $event)},"on-formula-img":_vm.onFormulaImg}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }